module.exports = __webpack_public_path__ + "static/favicon.185453e8.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/favicon.ico
// module id = 290
// module chunks = 114276838955818